if (!customElements.get('key-value-propositions')) {
  customElements.define('key-value-propositions', class extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('.key-value-propositions__list');
      this.track = this.querySelector('.key-value-propositions__track');
      if (!this.list || this.list.children.length < 2) return;

      this.motion = window.matchMedia('(max-width: 749px) and (prefers-reduced-motion: no-preference)');
      this.update = this.updateMarquee.bind(this);
      this.onPointerEnter = (event) => {
        if (event.pointerType !== 'mouse') return;
        this.hoverTimer = setTimeout(() => this.changePlaybackRate(0), 500);
      };
      this.onPointerLeave = () => {
        clearTimeout(this.hoverTimer);
        this.changePlaybackRate(1);
      };
      this.onBlockSelect = (event) => {
        if (!this.list.contains(event.target)) return;
        this.classList.add('is-editing');
        this.update();
      };
      this.onBlockDeselect = () => {
        this.classList.remove('is-editing');
        this.update();
      };
      this.addEventListener('pointerenter', this.onPointerEnter);
      this.addEventListener('pointerleave', this.onPointerLeave);
      this.motion.addEventListener('change', this.update);
      this.addEventListener('shopify:block:select', this.onBlockSelect);
      this.addEventListener('shopify:block:deselect', this.onBlockDeselect);
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.querySelector('.key-value-propositions__viewport'));
      this.observer.observe(this.list);
      this.update();
    }

    updateMarquee() {
      this.track.querySelectorAll('.key-value-propositions__copy').forEach(copy => copy.remove());
      const enabled = this.motion.matches && !this.classList.contains('is-editing');
      this.classList.toggle('is-ready', enabled);
      if (!enabled) return;

      const distance = this.list.getBoundingClientRect().width;
      if (!distance) return;
      this.track.style.setProperty('--key-value-propositions-distance', `${distance}px`);
      const copies = Math.ceil(this.getBoundingClientRect().width / distance);
      for (let i = 0; i < copies; i++) {
        const copy = this.list.cloneNode(true);
        copy.classList.add('key-value-propositions__copy');
        copy.setAttribute('aria-hidden', 'true');
        copy.inert = true;
        copy.querySelectorAll('[data-shopify-editor-block], [id]').forEach(node => {
          node.removeAttribute('data-shopify-editor-block');
          node.removeAttribute('id');
        });
        this.track.appendChild(copy);
      }
    }

    // Match Horizon's gentle hover slowdown without adding visible controls.
    changePlaybackRate(target) {
      cancelAnimationFrame(this.rateFrame);
      const animation = this.track.getAnimations()[0];
      if (!animation) return;
      const from = animation.playbackRate;
      const start = performance.now();
      const step = (now) => {
        const progress = Math.min((now - start) / 500, 1);
        const eased = progress * progress * (3 - 2 * progress);
        animation.updatePlaybackRate(from + (target - from) * eased);
        if (progress < 1) this.rateFrame = requestAnimationFrame(step);
      };
      this.rateFrame = requestAnimationFrame(step);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.motion?.removeEventListener('change', this.update);
      clearTimeout(this.hoverTimer);
      cancelAnimationFrame(this.rateFrame);
      this.removeEventListener('pointerenter', this.onPointerEnter);
      this.removeEventListener('pointerleave', this.onPointerLeave);
      this.removeEventListener('shopify:block:select', this.onBlockSelect);
      this.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
    }
  });
}
